import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import React from "react";
import { useTranslation } from "react-i18next";

import { skillsProfileTreemapChartConfig } from "./configs/skills_profile_config";

type GraphSwitcherProps = {
  graphData: any;
};

const GraphSwitcher = ({ graphData }: GraphSwitcherProps) => {
  const { t } = useTranslation("insights");

  let options = {
    tooltip: {
      formatter: (info) => {
        const { data } = info;
        const { treePathInfo } = info;
        const treePath = [];
        for (let i = 1; i < treePathInfo.length; i++) {
          /* @ts-ignore */
          treePath.push(treePathInfo[i].name);
        }
        let percentOfParent = undefined as any;
        // If we are not in the root of the path (Profinda), or the first level
        if (treePathInfo.length > 2) {
          const parentValue = treePathInfo[treePathInfo.length - 2].value;
          const currentValue = treePathInfo[treePathInfo.length - 1].value;
          percentOfParent = (currentValue / parentValue) * 100;
        }

        return `<div class="tooltip-title">${treePath.join("/")}</div>
          ${percentOfParent ? `${t("percentOfParent")}: ${percentOfParent.toFixed(2)}%` : ""}<br />
          ${t("percentOfTotal")}: ${data.value.toFixed(2)}%`;
      }
    },
    toolbox: {
      show: true,
      right: 20,
      feature: {
        saveAsImage: {
          title: t("saveImage"),
          backgroundColor: "transparent"
        }
      }
    },
    grid: {
      top: 50
    }
  };

  options = {
    ...options,
    ...skillsProfileTreemapChartConfig(graphData)
  };

  return <EchartsWrapper height={800} options={options} />;
};

export default GraphSwitcher;
